import React, { useContext, useEffect, useState } from 'react'
import './ComentariosPrivados.css'
import { deleteComentarioPrivado, getComentarioPrivadoById, getComentariosPrivadosByOferta, postComentarioPrivado, putComentarioPrivado } from '../../api/comentariosPrivados';
import { AuthContext } from '../../context/AuthContext';
import { ModalLayout } from '../ModalLayout';
import { Grid, TextField, Typography } from '@mui/material';
import { insertarBotonesModal } from '../../helpers/insertarBotonesModal';
import Swal from 'sweetalert2';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';


export const ComentariosPrivados = ({ oferta, idAnalisis, nombreAnalisis }) => {

    const [comentarios, setComentarios] = useState([]);
    const [comentarioEscrito, setComentarioEscrito] = useState('');
    const [comentarioEditar, setComentarioEditar] = useState([]);
    const [comentarioEliminar, setComentarioEliminar] = useState([]);

    const [openModal, setOpenModal] = useState(false);
    const [openModalEliminar, setOpenModalEliminar] = useState(false);

    const { user } = useContext(AuthContext);


    useEffect(() => {
        cargarComentarios();
    }, [oferta])

    const cargarComentarios = () => {
        getComentariosPrivadosByOferta(oferta).then(res => {
            setComentarios(res);
        })

    }

    const editarComentario = async (id) => {
        setOpenModal(true)
        const resp = await getComentarioPrivadoById(id)
        setComentarioEditar(prev => ({ ...prev, ...resp }))
    };

    const eliminarComentario = async (id) => {
        setOpenModalEliminar(true)
        const resp = await getComentarioPrivadoById(id)
        setComentarioEliminar(prev => ({ ...prev, ...resp }))
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (oferta === 0) {
            return;
        }
        if (comentarioEscrito === '') {
            return;
        }

        if (idAnalisis === undefined || nombreAnalisis === undefined) {
            return;
        }

        const comentario = {
            oferta: oferta,
            comentario: comentarioEscrito,
            nombreUsuario: user.nombre,
            apellidosUsuario: user.apellidos,
            nombreAnalisis: nombreAnalisis,
            idAnalisis: idAnalisis
        }

        await postComentarioPrivado(comentario);


        setComentarioEscrito('');
        cargarComentarios();
    }

    const handleChange = (event) => {
        setComentarioEscrito(event.target.value);
    }

    const handleChangeComentario = (e) => {
        const { name, value } = e.target;
        setComentarioEditar(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const peticionPutComentario = async () => {

        const resp = await putComentarioPrivado(comentarioEditar)

        cargarComentarios()

        Swal.fire({
            position: 'center',
            icon: 'info',
            title: 'Comentario Privado Modificado',
            text: `El comentario privado se ha modificado correctamente`,
            showConfirmButton: false,
            timer: 2000,
            showClass: {
                popup: 'animate__animated animate__bounceIn'
            },
            hideClass: {
                popup: 'animate__animated animate__bounceOut'
            }
        });
    }

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleCloseModalEliminar = () => {
        setOpenModalEliminar(false);
    };

    const peticionDeleteComentario = async () => {

        const resp = await deleteComentarioPrivado(comentarioEliminar.id)

        cargarComentarios()
        handleCloseModalEliminar()

        Swal.fire({
            position: 'center',
            icon: 'info',
            title: 'Comentario Privado Eliminado',
            text: `El comentario privado se ha eliminado correctamente`,
            showConfirmButton: false,
            timer: 2000,
            showClass: {
                popup: 'animate__animated animate__bounceIn'
            },
            hideClass: {
                popup: 'animate__animated animate__bounceOut'
            }
        });
    }

    return (
        <div>
            <p>Comentarios Privados Informes Fisico-Químico</p>
            <div className='comentarios-elementos-contenedor'>
                <div className='comentario-escrito2'>
                    <form onSubmit={handleSubmit}>
                        <input type='text' className='observacion-escrita2' value={comentarioEscrito} onChange={handleChange}
                            placeholder='Introduzca comentario privado + Enter'></input>
                    </form>
                </div>
                {
                    comentarios.map((comentario) => {
                        let fechaMostrar = new Date(comentario.fecha);
                        let fechaString = fechaMostrar.toLocaleDateString();

                        const esAutor = (user.nombre === comentario.nombreUsuario &&
                            user.apellidos === comentario.apellidosUsuario) || user.idPerfil === 1005;

                        return (
                            <div key={comentario.id}>
                                <h4>{comentario.nombreUsuario + ' ' + comentario.apellidosUsuario + ' ' + fechaString + ' ' + comentario.nombreAnalisis}
                                    {esAutor && (
                                        <>
                                            <EditIcon
                                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                                                onClick={() => editarComentario(comentario.id)}
                                            />
                                            <DeleteIcon
                                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                                                onClick={() => eliminarComentario(comentario.id)}
                                            />
                                        </>
                                    )}
                                </h4>
                                <p key={comentario.id}>{comentario.comentario}</p>
                            </div>
                        )
                    })
                }
            </div>

            <ModalLayout
                titulo="Editar Comentario Privado"
                contenido={
                    <Grid item xs={12}>
                        <Grid container sx={{ textAlign: 'center', pb: 2 }}>
                            <Grid item xs={12}>
                                <TextField
                                    sx={{ width: '100%' }}
                                    name="comentario"
                                    value={comentarioEditar && comentarioEditar.comentario}
                                    onChange={handleChangeComentario}
                                />
                            </Grid>
                        </Grid>

                    </Grid>
                }
                botones={[insertarBotonesModal(<AddIcon />, 'Guardar', async () => {
                    peticionPutComentario();
                })
                ]}
                open={openModal}
                onClose={handleCloseModal}
            />

            <ModalLayout
                titulo="Eliminar Comentario Privado"
                contenido={
                    <>
                        <Grid item xs={12}>
                            <Typography>¿Estás seguro que deseas eliminar este comentario privado?</Typography>
                        </Grid>
                    </>
                }
                botones={[
                    insertarBotonesModal(<DeleteIcon />, 'Eliminar', async () => {
                        peticionDeleteComentario();
                    }, 'error')
                ]}
                open={openModalEliminar}
                onClose={handleCloseModalEliminar}
            />
        </div>
    )
}